module.exports = __webpack_public_path__ + "img/CODINAFRICA.d7078b66.png";